import React from 'react';
import Achievement from './Achievement';
import { Contact } from './Contact';
import Education from './Education';
import Experience from './Experience';
import Footer from './Footer';
import Banner from './Header/Banner';
import Services from './Header/Service';
import Projects from './Projects';
import Skills from './Skills';

const Home = () => {
    return (
        <>
           <Banner></Banner> 
       
           <Skills></Skills>
        
           <Projects></Projects>
           <Experience></Experience>
           <Services></Services>
           <Education></Education>
           <Contact></Contact>
           
           <Footer></Footer>
        </>
    );
};

export default Home;